// Image URL utilities for handling both local and Cloudinary images

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

/**
 * Constructs the full image URL based on the image path
 * - If the path starts with "http", it's assumed to be a full URL (Cloudinary, etc.)
 * - If the path starts with "/uploads/", it's a local image and needs the backend URL
 * - Otherwise, it's treated as a relative path
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) {
    return '';
  }

  // If it's already a full URL (Cloudinary, etc.), return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // If it's a local path starting with /uploads/, prepend the backend URL
  if (imagePath.startsWith('/uploads/')) {
    return `${BACKEND_URL}${imagePath}`;
  }

  // For any other case, treat as relative path
  return imagePath;
};
